import {routerReducer, RouterState} from "react-router-redux";
import {combineReducers} from "redux";
import userReducer from './user';
import companyReducer from './companies'

export interface PerpetuaState {
  routing: RouterState;
}
export default combineReducers({routing: routerReducer, user: userReducer, companies: companyReducer});



// WEBPACK FOOTER //
// ./src/redux/reducers.js